import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { OnlineCardsQueryParams, OnlineCardsResponseData } from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const onlineCardKeys = {
  all: () => ['onlineCards'] as const,
  list: (props: OnlineCardsQueryParams) =>
    [
      ...onlineCardKeys.all(),
      'list',
      props.fetchUrl,
      props.queryParams,
    ] as const,
};

export const onlineCardQueries = {
  list: (props: OnlineCardsQueryParams) =>
    queryOptions({
      queryKey: onlineCardKeys.list(props),
      queryFn: () =>
        HttpClient.request<OnlineCardsResponseData>({
          method: 'GET',
          url: props.fetchUrl,
          params: props.queryParams,
        }),
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
    }),
};
